<p-dialog
  [(visible)]="visible"
  (onHide)="onClose()"
  header="Change Password"
  [modal]="true"
  [closable]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="change-password-dialog"
  [style]="{ width: '450px' }"
>
  <div class="change-password-form" [formGroup]="changePasswordForm">
    <!-- Old Password Field -->
    <div class="field mb-4">
      <label class="block text-sm font-medium text-gray-700 mb-2">
        Old password
      </label>
      <p-password
        inputId="oldPassword"
        formControlName="oldPassword"
        [feedback]="false"
        [toggleMask]="true"
        [placeholder]="'Enter your password'"
        [inputStyleClass]="
          'w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
        "
        class="password-field"
      ></p-password>
      @if (oldPassword?.invalid && oldPassword?.touched) {
      <div class="text-red-500 text-xs mt-1">
        @if (oldPassword?.errors?.['required']) { Old password is required }
      </div>
      }
    </div>

    <!-- New Password Field -->
    <div class="field mb-4">
      <label class="block text-sm font-medium text-gray-700 mb-2">
        New password
      </label>
      <p-password
        inputId="newPassword"
        formControlName="newPassword"
        [feedback]="false"
        [toggleMask]="true"
        [placeholder]="'Enter your password'"
        [inputStyleClass]="
          'w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
        "
        class="password-field"
      ></p-password>
      @if (newPassword?.invalid && newPassword?.touched) {
      <div class="text-red-500 text-xs mt-1">
        @if (newPassword?.errors?.['required']) { New password is required }
      </div>
      }
    </div>

    <!-- Confirm Password Field -->
    <div class="field mb-6">
      <label class="block text-sm font-medium text-gray-700 mb-2">
        Re-Enter password
      </label>
      <p-password
        inputId="confirmPassword"
        formControlName="confirmPassword"
        [feedback]="false"
        [toggleMask]="true"
        [placeholder]="'Enter your password'"
        [inputStyleClass]="
          'w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent'
        "
        class="password-field"
      ></p-password>
      @if (confirmPassword?.invalid && confirmPassword?.touched) {
      <div class="text-red-500 text-xs mt-1">
        @if (confirmPassword?.errors?.['required']) { Please confirm your password }
      </div>
      }
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-3">
      <p-button
        label="Cancel"
        (onClick)="onClose()"
        styleClass="p-button-text"
      ></p-button>
      <p-button
        [label]="isLoading ? 'Changing Password...' : 'Submit'"
        (onClick)="onSave()"
        [disabled]="changePasswordForm.invalid || isLoading"
        [loading]="isLoading"
        class="p-button-primary cursor-pointer"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
